import { defineMessages } from 'react-intl';

const messages = defineMessages({
  // Page SEO
  seoTitle: '{propertyName} - LodgeLink',
  // Common
  seeLess: 'See less',
  seeMore: 'See more',
  // Banner
  viewPhotos: 'View Photos',
  // Amenities
  amenities: 'Amenities',
  // Location
  location: 'Location',
  address: 'Address',
  // Affiliations
  affiliations: 'Affiliations',
  // Book Now
  bookNow: 'Book Now',
  selectRooms: 'Select Rooms',
  capacity: 'Max Occupancy',
  estimatedCost: 'Estimated cost (before taxes and fees)',
  hideRoomDetails: 'Hide room details',
  night: 'night',
  nightPlural: 'nights',
  perNightRate: '{name}/night',
  room: 'room',
  roomPlural: 'rooms',
  showRoomDetails: 'Show room details',
  averageRate: 'Average Rate',
  contactUs: '1-844-590-5465',
  pastDateSelected: 'Check-in date is in the past in the property time zone ({message})',
  pastDateCallToAction: 'Please select another check-in date.',
  // Similar Properties
  similarPropertiesTitle: 'Similar listings nearby',
  infoForNotLoggedInUserPart1: `LodgeLink has negotiated reduced rates with this property.`,
  infoForNotLoggedInUserPart2: ` for up-to-date availability and accurate pricing.`,
  signIn: 'Sign in',
  joinNow: 'Join Now',
  maxOccupancyNote: 'Note: Single Occupancy Rates Shown',
  callForAvailability: 'Please Call for Availability',
  callForPricing: 'Please Call for Additional Information',
  estimatedRate: 'Estimated Rate',
  errorMessageToast: '<p><strong>An error has occurred: </strong> {message}</p>',

  bookMarkText: 'This property is preferred by your organization',
  instantBookingProperty: 'This is an instant booking property',
  instantBookingPropertyHelper: '(Note: instant bookings are subject to availability)',
  blockBookingText: 'Block Booking',
  permissionDenied:
    'Your account does not allow for booking permissions. Please contact your administrator to perform this booking on your behalf.',
  restrictedRooms:
    'Your role permissions allows you to book only one room for yourself. If you have any questions or need assistance, please contact your administrators.'
});

export default messages;
